// Withdraw Unmasking Invitation
export const WITHDRAW_UNMASKING_INVITATION_REQUEST = 'WITHDRAW_UNMASKING_INVITATION_REQUEST';
export const WITHDRAW_UNMASKING_INVITATION_DONE = 'WITHDRAW_UNMASKING_INVITATION_DONE';
export const WITHDRAW_UNMASKING_INVITATION_FAILED = 'WITHDRAW_UNMASKING_INVITATION_FAILED';